import { CommissionAPI } from '@business/api/commission';
import { CommissionResponse } from '@business/entities/commission';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { Repository } from '@core/utils/repository';
import { switchMap } from 'rxjs/operators';
import { Blocs } from '../tokens';
import { CommissionFormData } from '@modules/settings/SettingsPage/Components/CommissionSettingsTab/CommissionTab';
import { showDeleteConfirmation } from '@modules/common';

export class CommissionBloc extends BaseBloc {
  private readonly commissionRepo = new Repository<CommissionResponse>({
    getItemId: tag => tag.id,
  });

  readonly commissions$ = this.commissionRepo.items$;

  onReset() {
    this.commissionRepo.reset();
  }

  fetchCommissions = () => {
    return CommissionAPI.fetchCommissions().pipe(this.commissionRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_commission_error') }));
  };

  getErrors = () => {
    return CommissionAPI.getErrors().pipe(handleMessage({ error: requestMessage('fetch_commission_error') }));
  };

  saveCommissions = (data: CommissionFormData) => {
    return CommissionAPI.saveCommissions(data).pipe(
      this.commissionRepo.ops.reset(),
      switchMap(() => resolve(Blocs.settings).fetchSettings()),
      handleMessage({
        type: requestMessage('save_commission'),
      }),
    );
  };

  saveManual = (data: any) => {
    return CommissionAPI.saveManualCommission(data).pipe(
      handleMessage({
        type: requestMessage('save_manual_commission'),
      }),
    );
  };

  updateManual = (id: string, data: any) => {
    return CommissionAPI.updateManualCommission(id, data).pipe(
      handleMessage({
        type: requestMessage('update_manual_commission'),
      }),
    );
  };

  deleteManual = (id: string) => {
    return showDeleteConfirmation('Delete', 'Are you sure you want to delete this manual commission?').pipe(
      switchMap(() => CommissionAPI.deleteManualCommission(id)),
      handleMessage({ type: requestMessage('delete_manual_commission') }),
    );
  };

  saveSplit = (data: any) => {
    return CommissionAPI.saveSplitOverrides(data).pipe(
      handleMessage({
        type: requestMessage('save_split_overrides'),
      }),
    );
  };
  getSplit = () => {
    return CommissionAPI.getSplitOverrides().pipe(
      handleMessage({
        error: requestMessage('fetch_split_overrides'),
      }),
    );
  };
}
